import { render, staticRenderFns } from "./EnterMoreDetails.vue?vue&type=template&id=8c60cafa&"
import script from "./EnterMoreDetails.vue?vue&type=script&lang=js&"
export * from "./EnterMoreDetails.vue?vue&type=script&lang=js&"
import style0 from "./EnterMoreDetails.vue?vue&type=style&index=0&id=8c60cafa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports